<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let fill = "#bcbfc3";
	//Constants
	//Variables
	//Functions
	//Do

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 22 22.004">
	<g>
		<g>
			<g>
				<g>
					<path
						d="M759.862 278.835a11 11 0 1 0 11 11 11.017 11.017 0 0 0-11-11zm0 21.111a10.109 10.109 0 1 1 10.106-10.106 10.108 10.108 0 0 1-10.106 10.106z"
						transform="translate(-748.862 -278.835)"
						fill={fill} />
				</g>
			</g>
		</g>
		<g>
			<path
				d="M765.988 302.267a.4.4 0 0 1-.4-.4v-10.45a.4.4 0 0 1 .793 0v10.453a.4.4 0 0 1-.393.397z"
				transform="translate(-758.081 -284.749)"
				fill={fill} />
		</g>
		<g>
			<path
				d="M756.541 299.6a.513.513 0 0 1-.331-.116.356.356 0 0 1 0-.561l15.343-13.023a.529.529 0 0 1 .661 0 .356.356 0 0 1 0 .561l-15.342 13.019a.512.512 0 0 1-.331.12z"
				transform="translate(-753.212 -282.03)"
				fill={fill} />
		</g>
		<g>
			<g transform="translate(8.106 5.802)">
				<circle cx="3.729" cy="3.729" r="3.729" fill={fill} />
			</g>
		</g>
	</g>
</svg>

<style lang="scss">
</style>
